module.exports = __webpack_public_path__ + "static/media/GLORY_4472.3f3bdc32.jpg";